import {
    AuthorizationsObject,
    OAuthProfile
} from '@dat/angular-auth';
import {
    Arbitrary,
    array,
    boolean,
    date,
    emailAddress,
    nat,
    option,
    record,
    string,
    stringMatching,
    uuid,
} from 'fast-check';
import { IDatiqUser } from './datiq-user.interface';
import { IDatiqUserResources } from '@dat/datiq-core/models';

const generatePhoneNumber: () => Arbitrary<string> = () =>
    stringMatching(/^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/g);

const generateOAuthProfile: () => Arbitrary<OAuthProfile> = () =>
    record({
        name: string(),
        oAuthId: string(),
        csbId: option(nat()),
        csbOrgId: option(string()),
        emailAddress: option(emailAddress()),
        groupId: option(uuid()),
        nickName: option(string()),
        officeId: option(uuid()),
        phoneNumber: option(generatePhoneNumber()),
        userId: option(uuid()),
        userName: option(string()),
    });

const generateAuthorizations: () => Arbitrary<AuthorizationsObject> = () =>
    record({
        permissions: array(string()),
        roles: array(string()),
    });

export const generateUserResources: () => Arbitrary<IDatiqUserResources> = () =>
    record({
        laneCreditsAvailable: option(nat()),
        laneCreditsLastUpdated: option(date()),
        laneCreditsUsed: option(nat()),
    });

export const generateUser: () => Arbitrary<IDatiqUser> = () =>
    record({
        id: string(),
        loaded: option(boolean()),
        loggedIn: option(boolean()),
        oAuthProfile: option(generateOAuthProfile()),
        authorizations: option(generateAuthorizations()),
        // TODO: fill in below commented out keys as needed
        // capabilities?: IDatiqUserCapabilities;
        // modals?: IDatiqUserModals;
        // uiStates?: IDatiqUserUiState;
        // cachedUis?: string[];
        resources: option(generateUserResources()),
    });
